import React from 'react';
import SummaryComponent from './SummaryComponent';
import { generateComponentDocs, generateStoryDocs } from '../../utils/documentationUtils';

// Mock Data
const mockData = {
  sites_visited: 12,
  counties_visited: 5,
  h2a_sites_visited: 8,
  visits_completed: 20,
  notes_created: 15,
  total_workers_reached: 150,
};

// Storybook metadata
export default {
  title: 'Components/Seasons/SummaryComponent',
  component: SummaryComponent,
  parameters: {
    layout: 'centered',
    ...generateComponentDocs(
      // What problem does it solve?
      `\nThe \`SummaryComponent\` provides a concise summary of key metrics related to season activities.
        \n\n###_**Key Features:**_
        \n- Displays essential data points, such as sites visited, counties visited, and workers reached.
        \n- Compact and easy-to-read layout designed for quick insights.\n\n`,
      // When & how to use it?
      `\n\nUse the \`SummaryComponent\` to display season-related metrics in a clear and structured format.
        \n\n###_**Key Features:**_
        \n- **Metrics Display**:
        \n  - Sites Visited
        \n  - Counties Visited
        \n  - H2A Sites Visited
        \n  - Visits Completed
        \n  - Notes Created
        \n  - Total Workers Reached\n\n`,
      // Current Usage
      '\nThe `SummaryComponent` is used to display season statistics on the Seasons page, providing quick insights into outreach efforts.\n\n',
      // Related Components
      '\n- **[Table](http://localhost:6006/?path=/docs/components-table--docs)**: Used for displaying detailed data alongside summaries.\n\n',
    ),
  },
  tags: ['autodocs'],
  argTypes: {
    data: {
      control: { type: 'object' },
      description: 'The data object containing summary metrics.',
      table: {
        type: { summary: 'object' },
        required: true,
      },
    },
  },
};

// Template for the stories
const Template = (args) => (
  <div style={{
    height: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
  }}
  >
    <SummaryComponent {...args} />
  </div>
);

// Story for the default summary
export const DefaultSummary = Template.bind({});
DefaultSummary.args = {
  data: mockData,
};
DefaultSummary.parameters = generateStoryDocs(
  // When is this variant used?
  '\nUse this variant to display the default summary metrics for a season.\n\n',
  // Where is it currently used on the product?
  '\nThe `SummaryComponent` is used on the Seasons page to provide an overview of season metrics.\n\n',
);

// Story for empty summary
export const EmptySummary = Template.bind({});
EmptySummary.args = {
  data: {},
};
EmptySummary.parameters = generateStoryDocs(
  // When is this variant used?
  '\nUse this variant to display an empty summary when no data is available.\n\n',
  // Where is it currently used on the product?
  '\nThe `SummaryComponent` is used on the Seasons page to provide an overview of season metrics.\n\n',
);
